<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">代理佣金记录</div>
          <div class="money">
            ￥<span class="num">{{ commission }}</span>
          </div>
        </div>
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sales-query" v-if="TotalShow === 1">
      <div class="text-date-pick">
        <div class="text">团队吹风机销量：</div>
        <div class="sales-num">{{TotalCount === '' ? '请选择日期' : TotalCount + '单'}}</div>
      </div>
      <div class="date-pick">
          <div class="data-pick-item" 
          @click="selectDate('startTime')">{{startTime ? startTime : '开始日期'}}</div>
          <div class="data-pick-and">-</div>
          <div class="data-pick-item" 
          @click="selectDate('endTime')">{{endTime ? endTime : '结束日期'}}</div>
        </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item" v-for="(item, index) in info" :key="index">
          <div class="data">{{ item.time }}</div>
          <div class="listn" v-for="(val, indexn) in item.list" :key="indexn">
            <div
              class="itemn acea-row row-between-wrapper"
              :class="{ item_online: val.online == 0 }"
            >
              <div>
                <div class="name line1">{{ val.title }}</div>
                <div>{{ val.add_time }}</div>
              </div>
              <div class="item_online_label" v-if="val.online == 0">线下</div>
              <div class="num" v-if="val.pm == 1">+{{ val.number }}</div>
              <div class="num font-color-red" v-if="val.pm == 0">
                -{{ val.number }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
      v-model="currentDate"
      type="date"
      title="选择日期"
      @confirm="confirmDate"
      @cancel="show = false"
      :min-date="minDate"
      :max-date="maxDate"
      
    />
    </van-popup>

    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getCommissionInfo, getSpreadInfo , getSpreadTotalCount } from "../../../api/user";
import Loading from "@components/Loading";
import { DatetimePicker,Popup } from 'vant';
export default {
  name: "CommissionDetails",
  components: {
    Loading,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
  },
  props: {},
  data: function () {
    return {
      info: [],
      infoNoAgent: [],
      infoAgent: [],
      commission: 0,
      commissionNoAgent: 0,
      commissionAgent: 0,
      where: {
        page: 1,
        limit: 3,
        agentType: 0,
      },
      types: 3,
      loaded: false,
      loading: false,
      isagentType: 0,
      currentDate:'',
      show:false,
      dateType:'',
      startTime:'',
      endTime:'',
      TotalCount:'',//团队吹风机销量
      TotalShow:0,
      minDate: new Date(2018, 0, 1),
    };
  },
  mounted: function () {
    this.where.agentType = this.$store.state.app.userInfo.is_agent + 1;
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
    this.getSpreadTotalCount();
    this.getCurrentDate();
  },
  methods: {
    getIndex: function () {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getCommissionInfo(that.where, that.types).then(
        (res) => {
          that.loading = false;
          that.loaded = res.data.agent.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          // that.infoNoAgent.push.apply(that.infoNoAgent, res.data.district);
          that.info.push.apply(that.info, res.data.agent);

          // if (!that.isagentType) {
          //   that.info.push.apply(that.info, that.infoNoAgent);
          // }else {
          //   that.info.push.apply(that.info, that.infoAgent);

          // }
          // that.commissionNoAgent = res.data.commissionCount.district;
          that.commissionAgent = res.data.commissionCount.agent;
          that.commission = that.commissionAgent;
        },
        (error) => {
          that.$dialog.message(error.msg);
        }
      );
    },
    changeAgentlist: function (val) {
      if (val == 0) {
        this.info = this.infoNoAgent;
        this.commission = this.commissionNoAgent;
        this.isagentType = 0;
      } else if (val == 1) {
        this.info = this.infoAgent;
        this.commission = this.commissionAgent;
        this.isagentType = 1;
      }
    },
    selectDate(type){
      this.dateType = type;
      this.show = true;
    },
    confirmDate(value){
      let type = this.dateType;
      let date = new Date(value);
      let time = this.time(date);
      this[type] = time;
      if(this.startTime > this.endTime && this.startTime !== '' && this.endTime !== ''){
        this[type] = '';
        this.show = false;
        this.$dialog.message("开始日期不能大于结束日期");
      }else{
        this[type] = time;
        this.show = false;
      }
      if(this.startTime !== '' && this.endTime !== ''){
        let data = this.startTime + ' - ' + this.endTime;
        console.log(data)
        this.getSpreadTotalCount(data);
      }
      console.log(this.currentDate)
    },
    time(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    /**
     * 团队吹风机销量
     */
    getSpreadTotalCount(data){
      getSpreadTotalCount(data).then(res => {
        this.TotalShow = res.data.salecount.show;
        this.TotalCount = res.data.salecount.total;
      }).catch(err => {
        this.$dialog.message(res.msg);
      })
    },
    getCurrentDate(){
      let date = new Date();
      this.currentDate = date;
    }
  },
};
</script>
<style scoped>
.item_online {
  position: relative;
}
.sign-record .list .item .listn .itemn.item_online .num {
  color: #71a8d1;
}
.item_online_label {
  font-size: .26rem;
  line-height: 1.4em;
  width: 4em;
  background: #71a8d1;
  color: #ffffff;
  text-align: center;
}
.nav {
  background: #ffffff;
}
.nav_item {
  line-height: 3em;
  width: 50%;
  text-align: center;
}
.nav_item.on:after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 3em;
  height: .04rem;
  border-radius: 1px;
  background: #9dccd0;
}
.sales-query {
  display: flex;
  padding: .24rem .2rem;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  color: #5d5d5d;
  box-shadow: 0 1px 10px rgb(0, 0, 0,.08);
}
.sales-query .text-date-pick {
  display: flex;
  /* width: 100%; */
  padding: .08rem 0;
}
.sales-query .text {
  /* width: 1.6rem; */
}
.sales-query .date-pick {
  display: flex;
  align-items: center;
}
.sales-query .date-pick .data-pick-item{
  padding: .08rem 0;
}
.sales-query .date-pick .data-pick-and {
  padding: 0 .1rem;
}
.sales-query .sales-num {
  /* width: 1.24rem; */
  text-align: center;
}
</style>
